import { Link } from 'react-router-dom';

export default function AboutHero() {
  return (
    <section className="relative pt-32 pb-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-forest-green/30 via-deep-black to-deep-black"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
          <Link to="/" className="hover:text-copper transition-colors duration-200 cursor-pointer">
            Home
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-copper">About</span>
        </nav>

        {/* Heading */}
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="font-serif text-5xl lg:text-7xl text-white mb-6">
            About <span className="text-copper">High Standards</span>
          </h1>
          <div className="w-16 h-0.5 bg-copper mx-auto mb-8"></div>
          <p className="text-gray-300 text-xl leading-relaxed">
            Your trusted destination for premium smoke shop products in Eustis, Florida. We're committed to providing exceptional quality, expert guidance, and a sophisticated shopping experience.
          </p>
        </div>
      </div>
    </section>
  );
}
